import { useCookies } from 'vue3-cookies'
import { useMicros } from './micro'
import { ref, watch, onMounted } from 'vue'

// TODO: tiene sentido un composable genrico USE APP SHELL
export function useShellApp (props) {
  const { cookies } = useCookies()
  const micro = useMicros()

  const showContent = ref(!!props.show)
  const onHideContent = () => { showContent.value = false }

  watch(() => props.show, (val) => {
    showContent.value = val
  })

  onMounted(() => {
    cookies.remove('redirect_fcloud', '/', '.farmapremium.es')
    window.addEventListener('hide-content', onHideContent, false)
  })

  return {
    showContent,
    micro
  }
}
